import { useParams } from "react-router-dom";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { ACTION_TYPE, REPORT_NAME, REPORT_PATH } from "../constant/reportType";
import { Switch, Table, DatePicker } from "antd";
import { ENTITY_CAP_COLUMN, ENTITY_MASTER_COLUMN, ENTITY_TYPE_MASTER_COLUMN, FAMILY_OFFICE_MASTER_COLUMN, INVESTMENT_MANDATE_TYPE_COLUMN, SPONSOR_MASTER_COLUMN } from "../constant/AppConstant";
import { BsDownload, BsFillFileEarmarkBarGraphFill, BsPencilSquare, BsPlus, BsSearch } from "react-icons/bs";
import { alertMessage } from "../../utils/AlertService";
import { useAppSelector } from "../../redux-toolkit/hooks";
import Loading from "../Loading";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useDeleteEntityMasterMutation, useDownloadReportMutation, useGetAllEntityMasterBySearchMutation, useGetAllEntityMasterMutation } from "../../redux-toolkit/services/entityMasterService";
import { getAllEntityMasterBySearch, getAllEntityMasterDetails, getEntityMasterTotalRecords, setAllEntityMasterBySearch, setEntityMaster } from "../../redux-toolkit/slices/entityMasterSlice";
import { useDeleteSponsorMasterMutation, useGetAllSponsorMasterBySearchMutation, useGetAllSponsorMasterMutation } from "../../redux-toolkit/services/sponsorMasterService";
import { useDeleteFamilyOfficeMasterMutation, useGetAllFamilyOfficeMasterBySearchMutation, useGetAllFamilyOfficeMasterMutation } from "../../redux-toolkit/services/familyOfficeMasterService";
import { getAllSponsorMasterDetails, getSponsorMasterTotalRecords, setAllSponsorMasterBySearch, setSponsorMaster } from "../../redux-toolkit/slices/sponsorMasterSlice";
import { getAllFamilyOfficeMasterBySearch, getAllFamilyOfficeMasterDetails, getFamilyOfficeMasterTotalRecords, setAllFamilyOfficeMasterBySearch, setFamilyOfficeMaster } from "../../redux-toolkit/slices/familyOfficeMasterSlice";
import MasterData from "./MasterData";
import { getAllcountryDetail } from "../../redux-toolkit/slices/countrySlice";
import { useDeleteEntityTypeMasterMutation, useGetAllEntityTypeMasterBySearchMutation, useGetAllEntityTypeMasterMutation } from "../../redux-toolkit/services/entityTypeMasterService";
import { useDeleteInvestmentMandateTypeMutation, useGetAllInvestmentMandateTypeBySearchMutation, useGetAllInvestmentMandateTypeMutation } from "../../redux-toolkit/services/investmentMandateTypeService";
import { getAllEntityTypeMasterBySearch, getAllEntityTypeMasterDetails, getEntityTypeMasterTotalRecords, setAllEntityTypeMasterBySearch, setEntityTypeMaster } from "../../redux-toolkit/slices/entityTypeMasterSlice";
import { getAllInvestmentMandateTypeBySearch, getAllInvestmentMandateTypeDetails, getInvestmentMandateTypeTotalRecords, setAllInvestmentMandateTypeBySearch, setInvestmentMandateType } from "../../redux-toolkit/slices/investmentMandateTypeSlice";
import { FaFileAlt } from "react-icons/fa";
import { marked } from "marked";
import { useDeleteEntityCapMutation, useGetAllEntityCapBySearchMutation, useGetAllEntityCapMutation } from "../../redux-toolkit/services/entityCapService";
import { getAllEntityCapBySearch, getAllEntityCapDetails, getEntityCapTotalRecords, setAllEntityCapBySearch, setEntityCap } from "../../redux-toolkit/slices/entityCapSlice";
import { useDeleteMentorshipMasterMutation, useGetAllMentorshipMasterBySearchMutation, useGetAllMentorshipMasterMutation, useSearchMentorshipMasterByDateRangeMutation } from "../../redux-toolkit/services/mentorshipMasterService";
import { getAllMentorshipMasterBySearch, getAllMentorshipMasterDetails, getMentorshipMasterTotalRecords, setAllMentorshipMasterBySearch, setMentorshipMaster } from "../../redux-toolkit/slices/mentorshipMasterSlice";
import { MENTORSHIP_MASTER_COLUMN } from "../constant/AppConstant";

type Props = {};
const Master = (props: Props) => {

    const params = useParams();
    const dispatch = useDispatch();
    const localUserObj: any = getLocalStorageData("localUser");
    const token: any = getLocalStorageData("localUser").token;

    //state
    const [actionType, setActionType] = useState(ACTION_TYPE.ADD_ACTION) as any;
    const [reportName, setReportName]: any = useState();
    const [currentpage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [show, setShow] = useState(false);
    const [selectedRow, setSelectedRow]: any = useState([]);
    const [fromDate, setFromDate] = useState<any>(null);
    const [toDate, setToDate] = useState<any>(null);
    const [isDateSearchMode, setIsDateSearchMode] = useState(false);
    const [columData, setColumnData]: any = useState();
    const [dataSource, setDatasource]: any = useState([]);
    const [call, setCall] = useState("N");
    const [isCategory, setIsCategory] = useState(false);
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    const [previewType, setPreviewType]: any = useState<string | null>(null);
    const [html, setHtml] = useState("");
    const [recordData, setRecordData]: any = useState("");
    const [reportTitle, setReportTitle] = useState("Due Diligence");

    //getMutations
    const [getAllEntityMaster, allEntityMasterResponse] = useGetAllEntityMasterMutation();
    const [getAllEntityTypeMaster, allEntityTypeMasterResponse] = useGetAllEntityTypeMasterMutation();
    const [getAllInvestmentMandateType, allInvestmentMandateTypeResponse] = useGetAllInvestmentMandateTypeMutation();
    const [getAllSponsorMaster, allSponsorMasterResponse] = useGetAllSponsorMasterMutation();
    const [getAllFamilyOfficeMaster, allFamilyOfficeResponse] = useGetAllFamilyOfficeMasterMutation();
    const [getAllEntityCap, allEntityCapResponse] = useGetAllEntityCapMutation();
    const [getAllMentorshipMaster, allMentorshipMasterResponse] = useGetAllMentorshipMasterMutation();

    //search
    const [getAllEntityMasterWithSearch, allEntityMasterWithSearchResponse] = useGetAllEntityMasterBySearchMutation();
    const [getAllEntityTypeMasterWithSearch, allEntityTypeMasterWithSearchResponse] = useGetAllEntityTypeMasterBySearchMutation();
    const [getAllInvestmentMandateTypeWithSearch, allInvestmentMandateTypeWithSearchResponse] = useGetAllInvestmentMandateTypeBySearchMutation();
    const [getAllSponsorMasterWithSearch, allSponsorMasterWithSearchResponse] = useGetAllSponsorMasterBySearchMutation();
    const [getAllFamilyOfficeMasterWithSearch, allFamilyOfficeMasterWithSearchResponse] = useGetAllFamilyOfficeMasterBySearchMutation();
    const [getAllEntityCapWithSearch, allEntityCapWithSearchResponse] = useGetAllEntityCapBySearchMutation();
    const [getAllMentorshipMasterWithSearch, allMentorshipMasterWithSearchResponse] = useGetAllMentorshipMasterBySearchMutation();
    const [searchMentorshipMasterByDateRange, searchMentorshipMasterByDateRangeResponse] = useSearchMentorshipMasterByDateRangeMutation();

    //delete mutation
    const [deleteEntityMaster, deleteEntityMasterResponse] = useDeleteEntityMasterMutation();
    const [deleteEntityTypeMaster, deleteEntityTypeMasterResponse] = useDeleteEntityTypeMasterMutation();
    const [deleteInvestmentMandateType, deleteInvestmentMandateTypeResponse] = useDeleteInvestmentMandateTypeMutation();
    const [deleteSponsorMaster, deleteSponsorMasterResponse] = useDeleteSponsorMasterMutation();
    const [deleteFamilyOfficeMaster, deleteFamilyOfficeMasterResponse] = useDeleteFamilyOfficeMasterMutation();
    const [deleteEntityCap, deleteEntityCapResponse] = useDeleteEntityCapMutation();
    const [deleteMentorshipMaster, deleteMentorshipMasterResponse] = useDeleteMentorshipMasterMutation();

    const [downloadReport, downloadReportResponse] = useDownloadReportMutation();

    //totalRecords
    const totalEntityMaster: any = useAppSelector(getEntityMasterTotalRecords);
    const totalEntityTypeMaster: any = useAppSelector(getEntityTypeMasterTotalRecords);
    const totalInvestmentMandateType: any = useAppSelector(getInvestmentMandateTypeTotalRecords);
    const totalSponsorMaster: any = useAppSelector(getSponsorMasterTotalRecords);
    const totalFamilyOfficeMaster: any = useAppSelector(getFamilyOfficeMasterTotalRecords);
    const totalEntityCap: any = useAppSelector(getEntityCapTotalRecords);
    const totalMentorshipMaster: any = useAppSelector(getMentorshipMasterTotalRecords);

    //selector
    const allCountries: any = useAppSelector(getAllcountryDetail);

    const allEntityMaster: any = useAppSelector(getAllEntityMasterDetails)
    const allEntityMasterBySearch: any = useAppSelector(getAllEntityMasterBySearch);
    const allEntityTypeMaster: any = useAppSelector(getAllEntityTypeMasterDetails)
    const allEntityTypeMasterBySearch: any = useAppSelector(getAllEntityTypeMasterBySearch);
    const allInvestmentMandateType: any = useAppSelector(getAllInvestmentMandateTypeDetails)
    const allInvestmentMandateTypeBySearch: any = useAppSelector(getAllInvestmentMandateTypeBySearch);
    const allSponsorMaster: any = useAppSelector(getAllSponsorMasterDetails)
    const allSponsorMasterBySearch: any = useAppSelector(getAllEntityMasterBySearch);
    const allFamilyOfficeMaster: any = useAppSelector(getAllFamilyOfficeMasterDetails)
    const allFamilyOfficeMasterBySearch: any = useAppSelector(getAllFamilyOfficeMasterBySearch);
    const allEntityCap: any = useAppSelector(getAllEntityCapDetails)
    const allEntityCapBySearch: any = useAppSelector(getAllEntityCapBySearch);
    const allMentorshipMaster: any = useAppSelector(getAllMentorshipMasterDetails);
    const allMentorshipMasterBySearch: any = useAppSelector(getAllMentorshipMasterBySearch);

    useEffect(() => {
        switch (params.reportType) {
            case REPORT_PATH.ENTITY_MASTER:
                setReportName(REPORT_NAME.ENTITY_MASTER)
                break;
            case REPORT_PATH.ENTITY_TYPE_MASTER:
                setReportName(REPORT_NAME.ENTITY_TYPE_MASTER)
                break;
            case REPORT_PATH.INVESTMENT_MANDATE_TYPE:
                setReportName(REPORT_NAME.INVESTMENT_MANDATE_TYPE)
                break;
            case REPORT_PATH.SPONSOR_MASTER:
                setReportName(REPORT_NAME.SPONSOR_MASTER)
                break;
            case REPORT_PATH.FAMILY_OFFICE_MASTER:
                setReportName(REPORT_NAME.FAMILY_OFFICE_MASTER)
                break;
            case REPORT_PATH.ENTITY_CAP:
                setReportName(REPORT_NAME.ENTITY_CAP)
                break;
            case REPORT_PATH.MENTORSHIP_MASTER:
                setReportName(REPORT_NAME.MENTORSHIP_MASTER)
                break;
            default:
        }
    }, [params.reportType]);

    const handleFileShow = (record: any) => {
        setHtml("");
        if (!(record.fileData)) {
            setPreviewUrl(null);
            setPreviewType(null);
            return
        }

        // Revoke old preview if exists
        if (previewUrl) {
            URL.revokeObjectURL(previewUrl);
        }

        let mimeType = "application/octet-stream";

        if ((record.fileData).startsWith("/9j")) mimeType = "image/jpeg";
        else if ((record.fileData).startsWith("iVBOR")) mimeType = "image/png";
        else if ((record.fileData).startsWith("JVBER")) mimeType = "application/pdf";
        else if ((record.fileData).startsWith("UEsDB")) mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"; // XLSX
        else if ((record.fileData).startsWith("PK")) mimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document"; // DOCX (optional)

        // Convert Base64 → Blob
        const byteCharacters = atob((record.fileData));
        const byteNumbers = new Array(byteCharacters.length).fill(0)
            .map((_, i) => byteCharacters.charCodeAt(i));
        const blob = new Blob([new Uint8Array(byteNumbers)], { type: mimeType });

        const url = URL.createObjectURL(blob);
        setPreviewUrl(url);
        setPreviewType(mimeType);
    }

    const handleShowReport = (record: any) => {
        setPreviewUrl(null);
        setPreviewType(null);

        const response = JSON.parse(record?.llmResponse);
        const finalContent = response?.choices?.[0]?.message?.content || "";
        const html: any = marked(finalContent);
        setHtml(html);
        setRecordData(record);

        let title = "Due Diligence";
        if (record.llmRequest) {
            try {
                const req = JSON.parse(record.llmRequest);
                if (req.source === "SUCCESS_RISK_ASSESSMENT") {
                    title = "Successor Risk Assessment";
                }
            } catch (e) {
                // ignore
            }
        }
        setReportTitle(title);
    }

    useEffect(() => {
        const temp: any = [];
        const tempAction: any = {
            title: "Action",
            dataIndex: "action",
            key: "name",
            fixed: "right",
            width: 150,
            render: (index: any, record: any) => {
                return (
                    // for delete switch button
                    <div className="d-flex justify-content-between">
                        <div className="px-2 pe-auto">
                            <Switch
                                className={`${record.status === true ||
                                    record.enabled === true ||
                                    record.isActive === true ? "bg-accent" : "bg-secondry"}`}
                                checked={
                                    record.status === true ||
                                        record.enabled === true ||
                                        record.isActive === true
                                        ? true
                                        : false
                                }
                                onClick={() => {
                                    console.log(record, "record")
                                    onDeleteData(record);
                                }}
                            />
                        </div>
                        {reportName === REPORT_NAME.ENTITY_MASTER && (record.fileData !== null && record.fileData !== "") && (
                            <div
                                className="px-2 pe-auto"
                                onClick={() => {
                                    handleFileShow(record);
                                }}
                            >
                                <FaFileAlt size={18} color="#0078d4" />
                            </div>
                        )}
                        {record.status === true ||
                            record.enabled === true ||
                            record.isActive === true ? (
                            <div
                                className="px-2 pe-auto"
                                onClick={() => {
                                    handleOpenForm(record);
                                }}
                            >
                                <BsPencilSquare size={18} />
                            </div>
                        ) : null}
                    </div>
                );
            },
        };

        const tempAction2: any = {
            title: "Reports",
            dataIndex: "reports",
            key: "reports",
            fixed: "right",
            width: 120,
            render: (index: any, record: any) => {
                return (
                    <div className="d-flex justify-content-between">
                        {reportName === REPORT_NAME.ENTITY_MASTER &&
                            record?.llmResponse !== null &&
                            record?.llmResponse?.trim() !== "" && (
                                <div
                                    className="px-2 pe-auto"
                                    onClick={() => {
                                        handleShowReport(record);
                                    }}
                                >
                                    <BsFillFileEarmarkBarGraphFill size={18} color="#0078d4" />
                                </div>
                            )}
                    </div>
                );
            },
        };

        if (reportName === REPORT_NAME.ENTITY_MASTER && ENTITY_MASTER_COLUMN) {
            ENTITY_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            temp.push(tempAction2);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.ENTITY_TYPE_MASTER && ENTITY_TYPE_MASTER_COLUMN) {
            ENTITY_TYPE_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.INVESTMENT_MANDATE_TYPE && INVESTMENT_MANDATE_TYPE_COLUMN) {
            INVESTMENT_MANDATE_TYPE_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.SPONSOR_MASTER && SPONSOR_MASTER_COLUMN) {
            SPONSOR_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.FAMILY_OFFICE_MASTER && FAMILY_OFFICE_MASTER_COLUMN) {
            FAMILY_OFFICE_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.ENTITY_CAP && ENTITY_CAP_COLUMN) {
            ENTITY_CAP_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.MENTORSHIP_MASTER && MENTORSHIP_MASTER_COLUMN) {
            MENTORSHIP_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        }
    }, [reportName, params.reportType]);

    useEffect(() => {
        if (reportName === REPORT_NAME.ENTITY_MASTER) {
            getAllEntityMaster({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.ENTITY_TYPE_MASTER) {
            getAllEntityTypeMaster({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.INVESTMENT_MANDATE_TYPE) {
            getAllInvestmentMandateType({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.SPONSOR_MASTER) {
            setIsCategory(true);
            getAllSponsorMaster({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.FAMILY_OFFICE_MASTER) {
            setIsCategory(false);
            getAllFamilyOfficeMaster({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                orderBy: "desc",
            });
        } else if (reportName === REPORT_NAME.ENTITY_CAP) {
            setIsCategory(false);
            getAllEntityCap({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                orderBy: "desc",
            });
        } else if (reportName === REPORT_NAME.MENTORSHIP_MASTER) {
            setIsCategory(false);
            getAllMentorshipMaster({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                orderBy: "desc",
            });
        }
    }, [reportName]);

    useEffect(() => {
        if (call === "Y") {
            if (reportName === REPORT_NAME.ENTITY_MASTER) {
                getAllEntityMaster({
                    token: localUserObj?.token,
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "desc",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.ENTITY_TYPE_MASTER) {
                getAllEntityTypeMaster({
                    token: localUserObj?.token,
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "desc",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.INVESTMENT_MANDATE_TYPE) {
                getAllInvestmentMandateType({
                    token: localUserObj?.token,
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "desc",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.SPONSOR_MASTER) {
                setIsCategory(true);
                getAllSponsorMaster({
                    token: localUserObj?.token,
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "desc",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.FAMILY_OFFICE_MASTER) {
                setIsCategory(false);
                getAllFamilyOfficeMaster({
                    token: localUserObj?.token,
                    page: currentpage - 1,
                    size: pageSize,
                    orderBy: "desc",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.ENTITY_CAP) {
                setIsCategory(false);
                getAllEntityCap({
                    token: localUserObj?.token,
                    page: currentpage - 1,
                    size: pageSize,
                    orderBy: "desc",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.MENTORSHIP_MASTER) {
                setIsCategory(false);
                getAllMentorshipMaster({
                    token: localUserObj?.token,
                    page: currentpage - 1,
                    size: pageSize,
                    orderBy: "desc",
                });
                setCall("N");
            }
        }
    }, [call]);

    const paginationChange = (page: number, pageSize: number) => {
        if (reportName === REPORT_NAME.ENTITY_MASTER) {
            getAllEntityMaster({
                token: localUserObj?.token,
                page: page - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.SPONSOR_MASTER) {
            getAllSponsorMaster({
                token: localUserObj?.token,
                page: page - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.ENTITY_TYPE_MASTER) {
            getAllEntityTypeMaster({
                token: localUserObj?.token,
                page: page - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.INVESTMENT_MANDATE_TYPE) {
            getAllInvestmentMandateType({
                token: localUserObj?.token,
                page: page - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.FAMILY_OFFICE_MASTER) {
            getAllFamilyOfficeMaster({
                token: localUserObj?.token,
                page: page - 1,
                size: pageSize,
                orderBy: "desc",
            });
        } else if (reportName === REPORT_NAME.ENTITY_CAP) {
            getAllEntityCap({
                token: localUserObj?.token,
                page: page - 1,
                size: pageSize,
                orderBy: "desc",
            });
        } else if (reportName === REPORT_NAME.MENTORSHIP_MASTER) {
            setIsCategory(false);
            if (isDateSearchMode && fromDate && toDate) {
                searchMentorshipMasterByDateRange({
                    token: localUserObj?.token,
                    payload: {
                        fromDate: fromDate.format("YYYY-MM-DDTHH:mm:ss"),
                        toDate: toDate.format("YYYY-MM-DDTHH:mm:ss"),
                        pageNumber: page - 1,
                        offset: pageSize
                    }
                });
            } else {
                getAllMentorshipMaster({
                    token: localUserObj?.token,
                    page: page - 1,
                    size: pageSize,
                    orderBy: "desc",
                });
            }
        }
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleShow = () => {
        setActionType(ACTION_TYPE.ADD_ACTION);
        setShow(true)
    };

    const onDeleteData = (record: any) => {
        if (reportName === REPORT_NAME.ENTITY_MASTER) {
            deleteEntityMaster({ token: localUserObj?.token, id: record.id });

        } else if (reportName === REPORT_NAME.ENTITY_TYPE_MASTER) {
            deleteEntityTypeMaster({ token: localUserObj?.token, id: record.id });

        } else if (reportName === REPORT_NAME.INVESTMENT_MANDATE_TYPE) {
            deleteEntityMaster({ token: localUserObj?.token, id: record.id });

        } else if (reportName === REPORT_NAME.SPONSOR_MASTER) {
            deleteSponsorMaster({ token: localUserObj?.token, id: record.id });

        } else if (reportName === REPORT_NAME.FAMILY_OFFICE_MASTER) {
            deleteFamilyOfficeMaster({ token: localUserObj?.token, id: record.id });

        } else if (reportName === REPORT_NAME.ENTITY_CAP) {
            deleteEntityCap({ token: localUserObj?.token, id: record.id });
        } else if (reportName === REPORT_NAME.MENTORSHIP_MASTER) {
            deleteMentorshipMaster({ token: localUserObj?.token, id: record.id });
        }
    };

    useEffect(() => {
        if (deleteEntityMasterResponse.isSuccess) {
            if (deleteEntityMasterResponse.data?.isActive) {
                alertMessage("Entity Master enable successfully", "success");
            } else {
                alertMessage("Entity Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteEntityMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteEntityMasterResponse.isSuccess, deleteEntityMasterResponse.isError]);

    useEffect(() => {
        if (deleteEntityTypeMasterResponse.isSuccess) {
            if (deleteEntityTypeMasterResponse.data?.isActive) {
                alertMessage("Entity Type Master enable successfully", "success");
            } else {
                alertMessage("Entity Type Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteEntityTypeMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteEntityTypeMasterResponse.isSuccess, deleteEntityTypeMasterResponse.isError]);

    useEffect(() => {
        if (deleteInvestmentMandateTypeResponse.isSuccess) {
            if (deleteInvestmentMandateTypeResponse.data?.isActive) {
                alertMessage("Investment Mandate Type enable successfully", "success");
            } else {
                alertMessage("Investment Mandate Type deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteInvestmentMandateTypeResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteInvestmentMandateTypeResponse.isSuccess, deleteInvestmentMandateTypeResponse.isError]);

    useEffect(() => {
        if (deleteSponsorMasterResponse.isSuccess) {
            if (deleteSponsorMasterResponse.data?.isActive) {
                alertMessage("Sponsor Master enable successfully", "success");
            } else {
                alertMessage("Sponsor Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteSponsorMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteSponsorMasterResponse.isSuccess, deleteSponsorMasterResponse.isError]);

    useEffect(() => {
        if (deleteFamilyOfficeMasterResponse.isSuccess) {
            if (deleteFamilyOfficeMasterResponse.data?.isActive) {
                alertMessage("Family Office Master enable successfully", "success");
            } else {
                alertMessage("Family Office Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteFamilyOfficeMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteFamilyOfficeMasterResponse.isSuccess, deleteFamilyOfficeMasterResponse.isError]);

    useEffect(() => {
        if (deleteEntityCapResponse.isSuccess) {
            if (deleteEntityCapResponse.data?.isActive) {
                alertMessage("Entity Cap enable successfully", "success");
            } else {
                alertMessage("Entity Cap deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteEntityCapResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteEntityCapResponse.isSuccess, deleteEntityCapResponse.isError]);

    useEffect(() => {
        if (deleteMentorshipMasterResponse.isSuccess) {
            if (deleteMentorshipMasterResponse.data?.isActive) {
                alertMessage("Mentorship Master enable successfully", "success");
            } else {
                alertMessage("Mentorship Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteMentorshipMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteMentorshipMasterResponse.isSuccess, deleteMentorshipMasterResponse.isError]);

    const handleOpenForm = (record: any) => {
        setActionType(ACTION_TYPE.UPDATE_ACTION);
        setSelectedRow(record);
        setShow(true);
    };

    useEffect(() => {
        if (allEntityMasterResponse.isSuccess) {
            dispatch(setEntityMaster(allEntityMasterResponse));
        } else if (allEntityMasterResponse.isError) {
            let response: any = allEntityMasterResponse.error;
            alertMessage(response, "error");
        }

    }, [allEntityMasterResponse.isSuccess, allEntityMasterResponse.isError]);

    useEffect(() => {
        if (allEntityTypeMasterResponse.isSuccess) {
            dispatch(setEntityTypeMaster(allEntityTypeMasterResponse));
        } else if (allEntityTypeMasterResponse.isError) {
            let response: any = allEntityTypeMasterResponse.error;
            alertMessage(response, "error");
        }

    }, [allEntityTypeMasterResponse.isSuccess, allEntityTypeMasterResponse.isError]);

    useEffect(() => {
        if (allInvestmentMandateTypeResponse.isSuccess) {
            dispatch(setInvestmentMandateType(allInvestmentMandateTypeResponse));
        } else if (allInvestmentMandateTypeResponse.isError) {
            let response: any = allInvestmentMandateTypeResponse.error;
            alertMessage(response, "error");
        }

    }, [allInvestmentMandateTypeResponse.isSuccess, allInvestmentMandateTypeResponse.isError]);

    useEffect(() => {
        if (allSponsorMasterResponse.isSuccess) {
            dispatch(setSponsorMaster(allSponsorMasterResponse));
        } else if (allSponsorMasterResponse.isError) {
            let response: any = allSponsorMasterResponse.error;
            alertMessage(response, "error");
        }

    }, [allSponsorMasterResponse.isSuccess, allSponsorMasterResponse.isError]);

    useEffect(() => {
        if (allFamilyOfficeResponse.isSuccess) {
            dispatch(setFamilyOfficeMaster(allFamilyOfficeResponse));
        } else if (allFamilyOfficeResponse.isError) {
            let response: any = allFamilyOfficeResponse.error;
            alertMessage(response, "error");
        }

    }, [allFamilyOfficeResponse.isSuccess, allFamilyOfficeResponse.isError]);

    useEffect(() => {
        if (allEntityCapResponse.isSuccess) {
            dispatch(setEntityCap(allEntityCapResponse));
        } else if (allEntityCapResponse.isError) {
            let response: any = allEntityCapResponse.error;
            alertMessage(response, "error");
        }

    }, [allEntityCapResponse.isSuccess, allEntityCapResponse.isError]);

    useEffect(() => {
        if (allMentorshipMasterResponse.isSuccess) {
            dispatch(setMentorshipMaster(allMentorshipMasterResponse));
        } else if (allMentorshipMasterResponse.isError) {
            let response: any = allMentorshipMasterResponse.error;
            alertMessage(response, "error");
        }

    }, [allMentorshipMasterResponse.isSuccess, allMentorshipMasterResponse.isError]);

    const buildEntityMaster = (data: any) => {
        let temp: any = [];

        data.forEach((element: any) => {
            const country = allCountries?.find((c: any) => c.id === element.countryId);
            // let payload =
            temp.push({
                id: element.id,
                entityType: element?.entityType ? element?.entityType?.name : "",
                name: element.name ? element.name : "",
                code: element.code ? element.code : "",
                dob: element.dob,
                focusArea: element?.focusArea ? element?.focusArea : "",
                registrationNo: element?.registrationNo ? element?.registrationNo : "",
                country: country?.name ? country?.name : "",
                countryId: country?.id,
                fileData: element?.verificationFileUpload ? element?.verificationFileUpload : "",
                llmResponse: element?.llmResponse ? element?.llmResponse : "",
                llmRequest: element?.llmRequest ? element?.llmRequest : "",
                status: element.status,
                successorStatus: element?.successorStatus ?? "",
                contactPerson: element.contactPerson ? element.contactPerson : "",
                email: element.email ? element.email : "",
                phoneNumber: element.phoneNumber ? element.phoneNumber : "",
                websiteUrl: element.websiteUrl ? element.websiteUrl : "",
                parentEntityType: element?.parentEntityType?.name ?? "",
                parentEntity: element?.parentEntity?.name ?? "",
                authorizeShareCapital: element.authorizeShareCapital ? element.authorizeShareCapital : "",
                paidUpCapital: element.paidUpCapital ? element.paidUpCapital : "",
                currency: element.currency ? element.currency : "",
            });
        });
        setDatasource(temp);
    };

    const buildEntityCap = (data: any) => {
        let temp: any = [];
        data.forEach((element: any) => {
            temp.push({
                ...element,
                entity: element?.entity ? element.entity.name : "",
                entityType: element?.entityType ? element.entityType.name : "",
                shareholderEntity: element?.shareholderEntity ? element.shareholderEntity.name : "",
                shareholderEntityType: element?.shareholderEntityType ? element.shareholderEntityType.name : "",
            });
        });
        setDatasource(temp);
    };

    //data
    useEffect(() => {
        if (allEntityMaster && reportName === REPORT_NAME.ENTITY_MASTER) {
            buildEntityMaster(allEntityMaster);
        }
    }, [allEntityMaster]);

    useEffect(() => {
        if (allEntityTypeMaster && reportName === REPORT_NAME.ENTITY_TYPE_MASTER) {
            setDatasource(allEntityTypeMaster);
        }
    }, [allEntityTypeMaster]);

    useEffect(() => {
        if (allInvestmentMandateType && reportName === REPORT_NAME.INVESTMENT_MANDATE_TYPE) {
            setDatasource(allInvestmentMandateType);
        }
    }, [allInvestmentMandateType]);


    useEffect(() => {
        if (allSponsorMaster && reportName === REPORT_NAME.SPONSOR_MASTER) {
            setDatasource(allSponsorMaster)
        }
    }, [allSponsorMaster]);

    useEffect(() => {
        if (allFamilyOfficeMaster && reportName === REPORT_NAME.SPONSOR_MASTER) {
            setDatasource(allFamilyOfficeMaster)
        }
    }, [allFamilyOfficeMaster]);

    useEffect(() => {
        if (allEntityCap && reportName === REPORT_NAME.ENTITY_CAP) {
            buildEntityCap(allEntityCap);
        }
    }, [allEntityCap]);

    useEffect(() => {
        if (allMentorshipMaster && reportName === REPORT_NAME.MENTORSHIP_MASTER) {
            const data = allMentorshipMaster.map((item: any) => {
                return {
                    ...item,
                    entityMenteeName: item.entityMentee ? item.entityMentee.name : "",
                    entityTypeMenteeName: item.entityTypeMentee?.name || item.entityMentee?.entityType?.name || "",
                    entityMentorName: item.entityMentor ? item.entityMentor.name : "",
                    entityTypeMentorName: item.entityTypeMentor?.name || item.entityMentor?.entityType?.name || "",
                    fromDate: item.fromDate ? item.fromDate.split('T')[0] : "",
                    toDate: item.toDate ? item.toDate.split('T')[0] : "",
                }
            })
            setDatasource(data);
        }
    }, [allMentorshipMaster]);

    const handleSearch = (event: any) => {
        if (reportName === REPORT_NAME.ENTITY_MASTER) {
            getAllEntityMasterWithSearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.ENTITY_TYPE_MASTER) {
            getAllEntityTypeMasterWithSearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.INVESTMENT_MANDATE_TYPE) {
            getAllInvestmentMandateTypeWithSearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.SPONSOR_MASTER) {
            getAllSponsorMasterWithSearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.FAMILY_OFFICE_MASTER) {
            getAllFamilyOfficeMasterWithSearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.ENTITY_CAP) {
            getAllEntityCapWithSearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.MENTORSHIP_MASTER) {
            getAllMentorshipMasterWithSearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        }
    };

    useEffect(() => {
        if (allEntityMasterWithSearchResponse.isSuccess) {
            dispatch(setAllEntityMasterBySearch(allEntityMasterWithSearchResponse));
        } else if (allEntityMasterWithSearchResponse.isError) {
            let response: any = allEntityMasterWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [allEntityMasterWithSearchResponse.isSuccess, allEntityMasterWithSearchResponse.isError]);

    useEffect(() => {
        if (allEntityTypeMasterWithSearchResponse.isSuccess) {
            dispatch(setAllEntityTypeMasterBySearch(allEntityTypeMasterWithSearchResponse));
        } else if (allEntityTypeMasterWithSearchResponse.isError) {
            let response: any = allEntityTypeMasterWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [allEntityTypeMasterWithSearchResponse.isSuccess, allEntityTypeMasterWithSearchResponse.isError]);

    useEffect(() => {
        if (allInvestmentMandateTypeWithSearchResponse.isSuccess) {
            dispatch(setAllInvestmentMandateTypeBySearch(allInvestmentMandateTypeWithSearchResponse));
        } else if (allInvestmentMandateTypeWithSearchResponse.isError) {
            let response: any = allInvestmentMandateTypeWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [allInvestmentMandateTypeWithSearchResponse.isSuccess, allInvestmentMandateTypeWithSearchResponse.isError]);

    useEffect(() => {
        if (allSponsorMasterWithSearchResponse.isSuccess) {
            dispatch(setAllSponsorMasterBySearch(allSponsorMasterWithSearchResponse));
        } else if (allSponsorMasterWithSearchResponse.isError) {
            let response: any = allSponsorMasterWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [allSponsorMasterWithSearchResponse.isSuccess, allSponsorMasterWithSearchResponse.isError]);

    useEffect(() => {
        if (allFamilyOfficeMasterWithSearchResponse.isSuccess) {
            dispatch(setAllFamilyOfficeMasterBySearch(allFamilyOfficeMasterWithSearchResponse));
            // setDatasource(allFamilyOfficeMasterWithSearchResponse.data.data);
        } else if (allFamilyOfficeMasterWithSearchResponse.isError) {
            let response: any = allFamilyOfficeMasterWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [allFamilyOfficeMasterWithSearchResponse.isSuccess, allFamilyOfficeMasterWithSearchResponse.isError]);

    useEffect(() => {
        if (allEntityCapWithSearchResponse.isSuccess) {
            dispatch(setAllEntityCapBySearch(allEntityCapWithSearchResponse));
        } else if (allEntityCapWithSearchResponse.isError) {
            let response: any = allEntityCapWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [allEntityCapWithSearchResponse.isSuccess, allEntityCapWithSearchResponse.isError]);

    useEffect(() => {
        if (allEntityMasterBySearch && reportName === REPORT_NAME.ENTITY_MASTER) {
            buildEntityMaster(allEntityMasterBySearch);
        }
    }, [allEntityMasterBySearch]);

    useEffect(() => {
        if (allEntityTypeMasterBySearch && reportName === REPORT_NAME.ENTITY_TYPE_MASTER) {
            setDatasource(allEntityTypeMasterBySearch);
        }
    }, [allEntityTypeMasterBySearch]);

    useEffect(() => {
        if (allInvestmentMandateTypeBySearch && reportName === REPORT_NAME.INVESTMENT_MANDATE_TYPE) {
            setDatasource(allInvestmentMandateTypeBySearch);
        }
    }, [allInvestmentMandateTypeBySearch]);

    useEffect(() => {
        if (allSponsorMasterBySearch && reportName === REPORT_NAME.SPONSOR_MASTER) {
            setDatasource(allSponsorMasterBySearch);
        }
    }, [allSponsorMasterBySearch]);

    useEffect(() => {
        if (allFamilyOfficeMasterBySearch && reportName === REPORT_NAME.FAMILY_OFFICE_MASTER) {
            setDatasource(allFamilyOfficeMasterBySearch);
            // buildValueChainDataSource(allFamilyOfficeMasterBySearch);
        }
    }, [allFamilyOfficeMasterBySearch]);

    useEffect(() => {
        if (allEntityCapBySearch && reportName === REPORT_NAME.ENTITY_CAP) {
            buildEntityCap(allEntityCapBySearch);
        }
    }, [allEntityCapBySearch]);

    useEffect(() => {
        if (allMentorshipMasterBySearch && reportName === REPORT_NAME.MENTORSHIP_MASTER) {
            const data = allMentorshipMasterBySearch.map((item: any) => {
                return {
                    ...item,
                    entityMenteeName: item.entityMentee ? item.entityMentee.name : "",
                    entityTypeMenteeName: item.entityTypeMentee?.name || item.entityMentee?.entityType?.name || "",
                    entityMentorName: item.entityMentor ? item.entityMentor.name : "",
                    entityTypeMentorName: item.entityTypeMentor?.name || item.entityMentor?.entityType?.name || "",
                    fromDate: item.fromDate ? item.fromDate.split('T')[0] : "",
                    toDate: item.toDate ? item.toDate.split('T')[0] : "",
                }
            })
            setDatasource(data);
        }
    }, [allMentorshipMasterBySearch]);

    useEffect(() => {
        if (searchMentorshipMasterByDateRangeResponse.isSuccess) {
            dispatch(setAllMentorshipMasterBySearch(searchMentorshipMasterByDateRangeResponse));
        } else if (searchMentorshipMasterByDateRangeResponse.isError) {
            let response: any = searchMentorshipMasterByDateRangeResponse.error;
            alertMessage(response, "error");
        }
    }, [searchMentorshipMasterByDateRangeResponse.isSuccess, searchMentorshipMasterByDateRangeResponse.isError]);

    const handleDateSearch = () => {
        if (!fromDate || !toDate) {
            alertMessage("Please select both From and To dates", "error");
            return;
        }
        if (fromDate.isAfter(toDate)) {
            alertMessage("From date must be before To date", "error");
            return;
        }
        setCurrentPage(1);
        setIsDateSearchMode(true);
        searchMentorshipMasterByDateRange({
            token: localUserObj?.token,
            payload: {
                fromDate: fromDate.format("YYYY-MM-DDTHH:mm:ss"),
                toDate: toDate.format("YYYY-MM-DDTHH:mm:ss"),
                pageNumber: 0,
                offset: pageSize
            }
        });
    };

    const resetDateSearch = () => {
        setFromDate(null);
        setToDate(null);
        setIsDateSearchMode(false);
        setCurrentPage(1);
        getAllMentorshipMaster({
            token: localUserObj?.token,
            page: 0,
            size: pageSize,
            orderBy: "desc",
        });
    };

    const handleDownloadRreport = () => {
        if (reportName === REPORT_NAME.ENTITY_MASTER) {
            // recordData
            const tableData = [
                {
                    code: recordData.code,
                    name: recordData.name,
                    entityType: recordData.entityType,
                    registrationNo: recordData.registrationNo,
                    country: recordData.country,
                    contactPerson: recordData.contactPerson,
                    phoneNumber: recordData.phoneNumber,
                    email: recordData.email,
                    websiteUrl: recordData.websiteUrl,
                    focusArea: recordData.focusArea,
                    status: recordData.status,
                    successorStatus: recordData.successorStatus
                }
            ]

            const response = JSON.parse(recordData?.llmResponse);
            const finalContent = response?.choices?.[0]?.message?.content || "";

            const payload = {
                tableData: tableData,     // array of RowData
                llmResponse: finalContent         // HTML string from LLM
            };

            downloadReport({
                token: localUserObj?.token,
                payload
            })
                .unwrap()
                .then((blob) => {
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = "Entity_Report.pdf";
                    link.click();
                    window.URL.revokeObjectURL(url);

                    alertMessage("Report downloaded successfully", "success");
                })
                .catch((error) => {
                    alertMessage("Error while downloading", "error");
                });
        }
    }

    return (
        <div className="mt-2 overflow-y-auto">
            <div className="d-flex align-items-center justify-content-between flex-sm-row flex-column mb-2">
                <div className="d-flex align-items-center w-100 px-2">
                    <h5
                        className="m-0 px-0 d-flex align-items-center text-accent"
                        style={{ fontWeight: "700" }}
                    >
                        {reportName}
                    </h5>
                </div>
                <div className="d-flex align-items-center justify-content-start justify-content-sm-end cursor-pointer w-100 flex-wrap" style={{ gap: '8px' }}>

                    {reportName === REPORT_NAME.MENTORSHIP_MASTER && (
                        <div className="d-flex align-items-center mt-1" style={{ gap: '8px' }}>
                            <DatePicker
                                placeholder="From Date"
                                value={fromDate}
                                onChange={(date) => setFromDate(date)}
                            />
                            <DatePicker
                                placeholder="To Date"
                                value={toDate}
                                onChange={(date) => setToDate(date)}
                            />
                            <Button
                                className="bg-accent d-flex align-items-center border-0 text-white"
                                size="sm"
                                onClick={handleDateSearch}
                                style={{ height: "32px", padding: "0 12px" }}
                            >
                                <BsSearch size={14} className="me-1" /> Search
                            </Button>
                            {isDateSearchMode && (
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    onClick={resetDateSearch}
                                    className="d-flex align-items-center bg-white border border-secondary"
                                    style={{ height: "32px", padding: "0 12px" }}
                                >
                                    Reset
                                </Button>
                            )}
                        </div>
                    )}

                    <div className="d-flex flex-column" style={{ minWidth: "200px" }}>
                        <div className="input-group px-2 mt-1">
                            <Form.Control
                                type="search"
                                placeholder="Search"
                                className="border-0 bg-cm-light-primary1"
                                aria-label="Search"
                                onChange={handleSearch}
                            />
                            <div className="input-group-append bg-cm-light-primary1 p-1 rounded-end">
                                <span className="input-group-text bg-cm-light-primary1 border-0">
                                    {/* <img src={gear} alt="" /> */}
                                    <BsSearch className=" bg-cm-light-primary1 border-cm-light-primary1" />
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex px-2 align-items-center mt-1">
                        <Button
                            // variant="primary"
                            className="d-flex align-items-center me-0 text-nowrap bg-accent"
                            onClick={handleShow}
                        >
                            <BsPlus />
                            Add
                        </Button>
                    </div>
                    {allEntityMasterResponse.isLoading
                        ? (
                            <Loading />
                        ) : (
                            ""
                        )}
                    {show && (
                        <MasterData
                            show={show}
                            setShow={setShow}
                            actionType={actionType}
                            reportName={reportName}
                            data={selectedRow}
                            setCall={setCall}
                            isCategory={isCategory}
                            setIsCategory={setIsCategory}
                        />
                    )}
                </div>
            </div>

            {reportName === REPORT_NAME.ENTITY_CAP && (
                <div className="d-flex w-100 mb-3" style={{ gap: '16px' }}>
                    <div className="flex-fill p-3 rounded text-center" style={{ backgroundColor: '#f0f5ff' }}>
                        <div style={{ fontSize: '13px', color: '#666' }}>Total Entities</div>
                        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#1890ff' }}>
                            {dataSource ? new Set(dataSource.map((item: any) => item.entity).filter((val: any) => val)).size : 0}
                        </div>
                    </div>
                    <div className="flex-fill p-3 rounded text-center" style={{ backgroundColor: '#f6ffed' }}>
                        <div style={{ fontSize: '13px', color: '#666' }}>Total Shareholders</div>
                        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#52c41a' }}>
                            {dataSource ? new Set(dataSource.map((item: any) => item.shareholderEntity).filter((val: any) => val)).size : 0}
                        </div>
                    </div>
                    <div className="flex-fill p-3 rounded text-center" style={{ backgroundColor: '#f9f0ff' }}>
                        <div style={{ fontSize: '13px', color: '#666' }}>Avg Holding</div>
                        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#722ed1' }}>
                            {dataSource?.length > 0 ? (dataSource.reduce((acc: number, curr: any) => acc + (Number(curr.percentageHolding) || 0), 0) / dataSource.length).toFixed(1) : 0}%
                        </div>
                    </div>
                </div>
            )}

            {reportName === REPORT_NAME.MENTORSHIP_MASTER && (
                <div className="d-flex w-100 mb-3" style={{ gap: '16px' }}>
                    <div className="flex-fill p-3 rounded text-center" style={{ backgroundColor: '#f0f5ff' }}>
                        <div style={{ fontSize: '13px', color: '#666' }}>Total Hours</div>
                        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#1890ff' }}>
                            {dataSource?.length > 0 ? dataSource.reduce((acc: number, curr: any) => acc + (Number(curr.hours) || 0), 0).toFixed(1) : 0}h
                        </div>
                    </div>
                    <div className="flex-fill p-3 rounded text-center" style={{ backgroundColor: '#f6ffed' }}>
                        <div style={{ fontSize: '13px', color: '#666' }}>Unique Heirs</div>
                        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#52c41a' }}>
                            {dataSource ? new Set(dataSource.map((item: any) => item.entityMenteeName).filter((val: any) => val)).size : 0}
                        </div>
                    </div>
                    <div className="flex-fill p-3 rounded text-center" style={{ backgroundColor: '#f9f0ff' }}>
                        <div style={{ fontSize: '13px', color: '#666' }}>Unique Mentors</div>
                        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#722ed1' }}>
                            {dataSource ? new Set(dataSource.map((item: any) => item.entityMentorName).filter((val: any) => val)).size : 0}
                        </div>
                    </div>
                    <div className="flex-fill p-3 rounded text-center" style={{ backgroundColor: '#fff7e6' }}>
                        <div style={{ fontSize: '13px', color: '#666' }}>Avg Session</div>
                        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#fa8c16' }}>
                            {dataSource?.length > 0 ? (dataSource.reduce((acc: number, curr: any) => acc + (Number(curr.hours) || 0), 0) / dataSource.length).toFixed(1) : 0}h
                        </div>
                    </div>
                </div>
            )}

            <div className="mt-3 my-2 w-100 overflow-x-auto rounded-3">
                <Table
                    bordered={true}
                    rowKey={"id"}
                    scroll={{ x: 'max-content' }}
                    tableLayout="fixed"
                    pagination={{
                        total: (() => {
                            switch (reportName) {
                                case REPORT_NAME.ENTITY_MASTER:
                                    return totalEntityMaster;
                                case REPORT_NAME.ENTITY_TYPE_MASTER:
                                    return totalEntityTypeMaster;
                                case REPORT_NAME.INVESTMENT_MANDATE_TYPE:
                                    return totalInvestmentMandateType;
                                case REPORT_NAME.SPONSOR_MASTER:
                                    return totalSponsorMaster;
                                case REPORT_NAME.FAMILY_OFFICE_MASTER:
                                    return totalFamilyOfficeMaster;
                                case REPORT_NAME.ENTITY_CAP:
                                    return totalEntityCap;
                                case REPORT_NAME.MENTORSHIP_MASTER:
                                    return totalMentorshipMaster;
                                default:
                                    return dataSource.length;
                            }
                        })(),
                        responsive: true,
                        current: currentpage,
                        // showSizeChanger: true,  
                        pageSizeOptions: [10, 20, 30],
                        onChange: (page, pageSize) => {
                            paginationChange(page, pageSize);
                        },
                        pageSize: pageSize,
                    }}
                    columns={columData}
                    dataSource={dataSource}
                />
            </div>
            <div className="file-preview" style={{ marginTop: "20px" }}>
                {previewUrl && (
                    <>
                        {/* IMAGE VIEWER */}
                        {(previewType.includes("image")) && (
                            <img
                                src={previewUrl}
                                alt="Preview"
                                style={{ maxWidth: "100%", borderRadius: "8px" }}
                            />
                        )}

                        {/* PDF VIEWER */}
                        {previewType === "application/pdf" && (
                            <iframe
                                src={previewUrl}
                                width="100%"
                                height="500px"
                                style={{ border: "1px solid #ccc", borderRadius: "8px" }}
                            />
                        )}

                        {/* EXCEL / WORD / ZIP — cannot be previewed */}
                        {(previewType.includes("spreadsheet") ||
                            previewType.includes("word") ||
                            previewType.includes("octet-stream")) && (
                                <a href={previewUrl} download="document" style={{ color: "blue" }}>
                                    Click here to download file
                                </a>
                            )}
                    </>
                )}
            </div>
            {html && (
                <div>
                    <div className="d-flex justify-content-end">
                        <Button
                            // variant="primary"
                            className="d-flex align-items-center me-0 text-nowrap bg-accent"
                            onClick={handleDownloadRreport}
                        >
                            <BsDownload className="me-1" />
                            Download Report
                        </Button>
                    </div>
                    <div style={{
                        border: "2px solid #ddd",
                        padding: "16px",
                        borderRadius: "8px",
                        marginTop: "20px",
                        textAlign: "left"
                    }}>
                        <h2>{reportTitle}</h2>
                        <div
                            className="mt-5"
                            dangerouslySetInnerHTML={{ __html: html }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
export default Master;